import React from 'react';
import { Modal } from 'antd';
import { DataEditorForm } from './data-editor-form';
import { Column, CrudConfig } from '@src/model/table';
import { EditorMode } from '@src/utils/enums';
import { toLowerWithDivider } from '@src/utils/string-normalization';
import { useStores } from '@src/components/store';
import { observer } from 'mobx-react-lite';

interface DataEditorModalProps<T> {
    isOpen: boolean;
    closeModal: () => void;
    rowData?: T | null;
    columnsConfig: Column<T>[];
    onSave: (editedRowData: T) => Promise<void>;
    crudConfig?: CrudConfig<T>;
    mode?: EditorMode;
    header: string;
    okBtnText: string;
    duplicationValidator?: (record: T, originalRecord: T | undefined, keys: string[]) => boolean;
    data: T[];
    InfoMsg?: React.FC<{ data: any }>;
}

export const DataEditorModal = observer(<T,>(props: DataEditorModalProps<T>) => {

    const { customerStore } = useStores();

    const {
        isOpen,
        closeModal,
        rowData,
        columnsConfig,
        onSave,
        crudConfig,
        mode,
        header,
        okBtnText,
        duplicationValidator,
        data,
        InfoMsg
    } = props;

    return (
        <Modal
            destroyOnClose
            open={isOpen}
            footer={null}
            onCancel={closeModal}
            wrapClassName={`data-editor-form-modal ${customerStore.selectedLocation?.serviceLevel.toLowerCase()} ${toLowerWithDivider(crudConfig?.entityName)}`}
            width={crudConfig?.modalWidth ?? 740}>
            {rowData && (
                <DataEditorForm
                    formData={rowData}
                    fieldsConfig={columnsConfig}
                    onSave={onSave}
                    close={closeModal}
                    dataChangesHandler={crudConfig?.dataChangesHandler}
                    mode={mode}
                    header={header}
                    okBtnText={okBtnText}
                    duplicationValidator={duplicationValidator}
                    allData={data}
                    InfoMsg={InfoMsg}
                    getDisableSaveAlert={crudConfig?.getDisableSaveAlert}
                />
            )}
        </Modal>
    );
});